import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

import { Box } from '../../core';
import LoadingShimmer from '../LoadingShimmer';

const LoadingIndicator = ({ isLoading }: { isLoading: boolean }): JSX.Element | null => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',

        ...(isReactNative()
          ? {
              height: '100%',
              left: '5%',
              width: '100%',
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
            }
          : {
              top: '50%',
              left: '50%',
              width: '100%',
              transform: 'translate(-50%, -50%)',
              zIndex: 100,
            }),
      }}
    >
      <LoadingShimmer mt="0x" height={25} />
      <LoadingShimmer mt="5x" height={25} />
      <LoadingShimmer mt="5x" height={25} />
      <LoadingShimmer mt="5x" height={25} />
    </Box>
  );
};

export default LoadingIndicator;
